'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import shouldDisablePopups from '@/utils/shouldDisablePopups';
const toggleablePopupScripts = ['https://cdn.cookielaw.org/scripttemplates/otSDKStub.js?did=', 'www.lightboxcdn.com/vendor/'];
const usePopupObserver = () => {
  const $ = _c(2);
  const observerRef = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (!shouldDisablePopups()) {
        return;
      }
      observerRef.current = new MutationObserver(_temp);
      const observerTargets = [document.head, document.body].filter(Boolean);
      observerTargets.forEach(target => observerRef.current?.observe(target, {
        childList: true
      }));
      return () => {
        observerRef.current?.disconnect();
        observerRef.current = null;
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
};
export default usePopupObserver;
function _temp(mutations) {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node instanceof HTMLScriptElement && toggleablePopupScripts.some(src => node.src?.includes(src))) {
        node.remove();
      }
    }
  }
}